import {SET_TRAVELLER_ID, SET_USER_LOGGED, SET_MEMBERSHIP_INFO} from 'od-modules/secure_store/actions';

const buildUser = (entry) => {
    const user = entry || {};
    const {email, membershipInfoDTO} = user;
    const hasMembership = membershipInfoDTO && membershipInfoDTO.membershipDTO && membershipInfoDTO.membershipDTO.status === 'ACTIVATED';
    const {name, lastNames, membershipType} = hasMembership ? membershipInfoDTO.membershipDTO : {};
    const membershipDTO = hasMembership ? {name, lastNames, membershipType} : null;

    return {
        email,
        membershipDTO,
    };
};

export default function userDTO(state = {}, action) {
    switch (action.type) {
        case SET_USER_LOGGED:
            return Object.assign({}, state, buildUser(action.entry));
        case SET_TRAVELLER_ID:
            return Object.assign({}, state, {id: action.entry});
        case SET_MEMBERSHIP_INFO:
            return Object.assign({}, state, {membershipDTO: action.entry});
        default:
            return state;
    }
}
